import { NgModule } from "@angular/core";
import { MoreDropdownElement, NavBarElement, NavItemElement } from "./navbar-directives";

@NgModule({
    declarations: [
        NavBarElement,
        MoreDropdownElement,
        NavItemElement
    ],
    exports: [
        NavBarElement,
        MoreDropdownElement,
        NavItemElement
    ]
  })
  export class NavbarDirectivesModule {}